<div class="m-content">
	<div class="dashboard">
		<div class="top-section">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-6 ">
						<div class="main-title font-20">
							MPR List
						</div>
					</div>
					<div class=" col-lg-6 create-batch-button float-right align-right">
						<button (click)="onBack()" type="button" class="btn btn-secondary m-btn m-btn--custom m-btn--outline-2x button-round">
							Back
						</button>
						<button *ngIf="isRoleRPL" data-toggle="modal" (click)="addMPRPopup()" class="btn m-btn--pill btn-primary blue-btn">
							<i class="la la-plus" aria-hidden="true"></i>Add MPR
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="fee-based-schemes-container">
			<div class="container-fluid">
				<div class="m-demo__preview target-details-boxes">
				</div>
				<app-table [table]="mprTable"></app-table>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="add-mpr" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Add MPR
				</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeModal>
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<ng-container *ngIf="reportMonthList.length > 0">
					<div>
						<p class="m--font-info">
							<!-- <i style ="font-weight: bold;"> Disclaimer  : Data for MPR reporting in SIP is available as on last closing day of the last month.</i> -->
							<i style ="font-weight: bold;"> Disclaimer  : Batches for which the result approval date by SSC lies between first and last day of the previous month shall become eligible for MPR of that month.</i>
						</p>
					</div>
				</ng-container>
				<form class="m-form m-form--fit m-form--label-align-right" [formGroup]="addReportForm">
					<div class="m-portlet__body">
						<div class="form-group m-form__group row">
							<label *ngIf="reportMonthList.length > 0" for="tp-details" class="col-4 col-form-label">
								Select Reporting Month:
							</label>
							<div class="col-8 row" *ngIf="reportMonthList.length > 0;else nomonths">
								<div class="form-select-side">
									<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
										<g>
											<path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
										</g>
									</svg>
								</div>
								<select class="form-control m-input" formControlName="reportingMonth" required>
									<option value="" disabled>Choose a Reporting Month</option>
									<option [ngValue]="tc" *ngFor="let tc of reportMonthList">{{tc}}</option>
								</select>
								<app-form-control-messages [control]="addReportForm.get('reportingMonth')" [name]="'Reporting Month'"></app-form-control-messages>
							</div>
							<ng-template #nomonths><h5><i class="flaticon-info m--icon-font-size-lg1"></i> No Months Available <br><small>(This may be due to that you have applied for all the latest months or the project duration is starting from this month)</small></h5></ng-template>
						</div>
					</div>
				</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn  btn-cancel" data-dismiss="modal">
					Cancel
				</button>
				<button type="button" class="btn btn-next" (click)="addMPR()" [disabled]="!addReportForm.valid">
					Continue
				</button>
			</div>
		</div>
	</div>
</div>

